import api from './api';
import { CardQrToken, CardValidationResult } from '../types';

export const cardService = {
  /** Token do dia do associado/dependente logado, usado no QR Code do cartão virtual */
  async getQrToken(): Promise<CardQrToken> {
    const response = await api.get<CardQrToken>('/meu-cartao/qr-token');
    return response.data;
  },

  /** Validação pública do cartão (rota aberta pelo QR Code) */
  async validate(hash: string, signature: string): Promise<CardValidationResult> {
    try {
      const response = await api.get<CardValidationResult>(
        `/cartao/validar/${hash}/${signature}`
      );
      return response.data;
    } catch (err: any) {
      // 404 = cartão não encontrado; o corpo já vem no formato de resultado
      if (err.response?.data?.reason) {
        return err.response.data;
      }
      throw err;
    }
  },

  /** URL pública gravada no QR Code */
  buildValidationUrl(token: CardQrToken): string {
    return `${window.location.origin}/validar-cartao/${token.hash}/${token.signature}`;
  },
};
